import { render } from "./PhoneNumberView.vue?vue&type=template&id=521c04c8"
import script from "./PhoneNumberView.vue?vue&type=script&lang=js"
export * from "./PhoneNumberView.vue?vue&type=script&lang=js"

import "./PhoneNumberView.vue?vue&type=style&index=0&id=521c04c8&lang=css"

import exportComponent from "C:\\Users\\Emertat\\Desktop\\p\\nazerhelp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__